export default __webpack_public_path__ + "static/media/credit-card-CVV.4e718f7b.svg";